import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import UsersTable from "./UsersTable";
import UsersHeader from "./UsersHeader";
import UsersDrawer from "./UsersDrawer";
import UserCrudSurface from "../../../components/users/UserCrudSurface";
// AUTHORIZATION
import { useScreenPermission } from "../../../customHooks/useScopedPermission";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const UserPage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { theme } = useSelector((state: RootState) => state.home);
  // Reads SCREEN_PERMISSION["users"] -- the same declaration Layout.tsx's
  // sidebar link reads -- instead of a permission hand-written here that
  // could (and did) drift from the sidebar's own copy.
  const allowed = useScreenPermission("users");

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {allowed ? (
        <div className={`layout__contentPage__${theme}`}>
          <UsersHeader />
          <UsersTable />
          <UsersDrawer />
          {/* Every user dialog, mounted once. The wizard.s Users step mounts the
              same component, so both screens offer one CRUD, not two. */}
          <UserCrudSurface />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default UserPage;
